<div class="subscription-complete">
    <h1 class="unsubscribe-complete-header">{{'label.Thanks' | translate}}</h1>
    <span class="subscription-complete-message">{{'message.UnsubscribeCompleted' | translate}}</span>
    <a (click)="onActivateEditMode()">{{'label.SubscribeAgain' | translate}}</a>
</div>
